"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconSize = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _TypographyVariantTypes = require("../RichText/TypographyVariantTypes");
var _ListItem = _interopRequireWildcard(require("./ListItem"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var getIconSize = size => {
  switch (size) {
    case 'small':
      return 16;
    case 'medium':
      return 20;
    case 'large':
      return 24;
    case 'extra large':
      return 32;
    default:
      return 16;
  }
};
exports.getIconSize = getIconSize;
var List = _ref => {
  var {
    items,
    showDivider = false,
    textSize,
    type = 'unordered',
    textStyle,
    iconSize
  } = _ref;
  var ListComponent = {
    ordered: _componentsWeb.OrderedList,
    unordered: _componentsWeb.List
  }[type];
  var iconSizeNum = getIconSize(iconSize);
  return /*#__PURE__*/_react.default.createElement(ListComponent, {
    showDivider: showDivider,
    variant: {
      size: textSize,
      compact: textStyle === 'compact'
    },
    testID: "list-testid"
  }, items === null || items === void 0 ? void 0 : items.map((item, index) => /*#__PURE__*/_react.default.createElement(_ListItem.default, {
    ListComponent: ListComponent,
    textSize: textSize,
    iconSize: iconSizeNum,
    item: item,
    key: index
  })));
};
List.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_ListItem.IListItem)).isRequired,
  type: _propTypes.default.oneOf(['ordered', 'unordered']),
  showDivider: _propTypes.default.bool,
  textSize: _propTypes.default.oneOf(_TypographyVariantTypes.ListSize),
  textStyle: _propTypes.default.oneOf(['default', 'compact']),
  iconSize: _propTypes.default.oneOf(_TypographyVariantTypes.IconSize)
};
var _default = exports.default = List;